var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardBooster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6579 11.5464L13.9579 20.2464L12.35 18.6384L10.886 17.1744L10.874 17.1624L10.25 16.5264C9.90196 16.1904 9.70996 15.7344 9.70996 15.2424C9.70996 14.9784 9.76996 14.7144 9.87796 14.4864C9.96196 14.2824 10.094 14.1024 10.25 13.9464L11.27 12.9264L13.2619 10.9344L14.8579 9.33844L17.7979 6.39844C19.3699 8.47444 20.9659 10.1664 22.6579 11.5464Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7547 10.9598C19.6947 11.4158 19.3107 11.7398 18.8667 11.7398C18.8307 11.7398 18.7827 11.7278 18.7347 11.7278L13.2627 10.9358L14.8587 9.33984L18.9987 9.93984C19.4907 10.0118 19.8267 10.4678 19.7547 10.9598Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9299 15.1597C17.8459 15.5917 17.4739 15.8917 17.0539 15.8917C16.9939 15.8917 16.9339 15.8797 16.8739 15.8677L9.87793 14.4877C9.96193 14.2837 10.0939 14.1037 10.2499 13.9477L11.2699 12.9277L17.2219 14.1037C17.7139 14.1997 18.0259 14.6677 17.9299 15.1597Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3497 18.6398C12.3137 18.7238 12.2657 18.8078 12.2057 18.8798C11.7497 19.5158 10.7657 20.2478 8.67771 20.0678C5.89371 19.8518 5.24571 20.8358 4.86171 21.4238C4.69371 21.6998 4.40571 21.8438 4.10571 21.8438C3.93771 21.8438 3.76971 21.7958 3.62571 21.6998C3.20571 21.4238 3.08571 20.8718 3.34971 20.4518C4.09371 19.2998 5.38971 18.0038 8.83371 18.2678C9.78171 18.3638 10.4777 18.1958 10.7537 17.8358C10.9217 17.6078 10.9097 17.3078 10.8857 17.1758L12.3497 18.6398Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34141 15.804C5.84461 15.804 5.44141 15.4008 5.44141 14.904C5.44141 14.4072 5.84461 13.998 6.34141 13.998C6.83821 13.998 7.24141 14.3952 7.24141 14.892V14.904C7.24141 15.4008 6.83821 15.804 6.34141 15.804Z",
    fill: "#C4C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7864 4.70783L26.2464 11.9438C26.2224 12.3758 25.9824 12.7358 25.6104 12.9038C25.4544 12.9878 25.2744 13.0238 25.0824 13.0238C24.8184 13.0238 24.5424 12.9398 24.3024 12.7838C24.2424 12.7358 24.1704 12.6998 24.1104 12.6398L10.9344 25.8158C10.7544 25.9958 10.5264 26.0798 10.2984 26.0798C10.0704 26.0798 9.84237 25.9958 9.66237 25.8158C9.31437 25.4678 9.31437 24.8918 9.66237 24.5438L22.6584 11.5478C20.9664 10.1678 19.3704 8.47583 17.7984 6.39983C17.6784 6.24383 17.5704 6.08783 17.4504 5.93183C17.1504 5.48783 17.0904 4.99583 17.2944 4.59983C17.4624 4.22783 17.8344 3.99983 18.2664 3.96383L25.5024 3.42383H25.5984C25.9104 3.42383 26.2224 3.54383 26.4384 3.77183C26.6904 4.02383 26.8104 4.35983 26.7864 4.70783Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardBooster);
export default __webpack_public_path__ + "static/media/reward-booster.a6403378d43c18ce8977480e17b128b9.svg";
export { ForwardRef as ReactComponent };